import { skipToken, useMutation, useQuery } from '@tanstack/react-query'

import { contentApi } from './api/content-api'
import { contentKeys } from './api/query-keys'

export function useContentMedia(entityId: string | null) {
  return useQuery({
    queryKey: contentKeys.media(entityId ?? ''),
    queryFn: entityId === null ? skipToken : () => contentApi.listMedia(entityId),
    staleTime: 0,
  })
}

export function useDeleteContentMedia(entityId: string) {
  return useMutation({
    mutationFn: (mediaId: string) => contentApi.deleteMedia(entityId, mediaId),
    meta: { invalidates: [contentKeys.root] },
  })
}

export const contentMediaDeleteErrorCodes = {
  CONTENT_MEDIA_IN_USE: 'A published document still uses this media. Unpublish or edit that document first.',
}

export function useContentGroups(entityId: string | null) {
  return useQuery({
    queryKey: contentKeys.groups(entityId ?? ''),
    queryFn: entityId === null ? skipToken : () => contentApi.listGroups(entityId),
  })
}
